module.exports = __webpack_public_path__ + "static/BG-3313cd26e1f86b7f330e6e4af08c4fde.png";